/**
 * Trigger a browser file-save dialog for a remote audio URL.
 *
 * We deliberately avoid `fetch()` here: prompt audio is served from
 * `obd3api.expressivr.com`, which does NOT respond with a permissive
 * `Access-Control-Allow-Origin` header. Any cross-origin fetch is therefore
 * blocked by CORS in the browser.
 *
 * Instead we drop a temporary `<a download>` link into the DOM and click it.
 * The server replies with `Content-Type: application/octet-stream`, which is
 * enough for every modern browser to download instead of navigating to the
 * file. The `download` attribute is ignored as a security measure when the
 * URL is cross-origin (the file will keep the server-side filename), but the
 * download itself still happens — which is the user-visible outcome we care
 * about.
 */
export function downloadPromptAudio(url: string, filename?: string): void {
  const a = document.createElement('a');
  a.href = url;
  if (filename) a.download = filename;
  a.rel = 'noopener';
  // Some browsers (older Safari) ignore programmatic clicks on links that
  // aren't in the DOM, so attach → click → remove.
  document.body.appendChild(a);
  a.click();
  a.remove();
}
